import { Controller } from "@hotwired/stimulus"

// Copies a link (data-clipboard-text-param on the button) and confirms it in the toast target.
// The exhibition's shared link carries ?via=galerie: the visits it brings are the gallery's.
// With a track URL, each copy is told to the server (lien_exposition_copie, docs/analytics.md):
// the workspace loads no PostHog script.
export default class extends Controller {
  static targets = ["toast"]
  static values = { trackUrl: String }

  declare readonly toastTarget: HTMLElement
  declare readonly hasTrackUrlValue: boolean
  declare readonly trackUrlValue: string
  private _timer?: number

  async copy(event: Event & { params: { text?: string, from?: string } }) {
    const text = event.params.text
    if (!text) return

    this._track(event.params.from)
    try {
      await navigator.clipboard.writeText(text)
      this._toast("Lien copié · les visites qu'il amène sont attribuées à votre galerie")
    } catch {
      // Clipboard refused (permissions, insecure context): show the link to copy by hand
      this._toast(text)
    }
  }

  _track(from?: string) {
    if (!this.hasTrackUrlValue) return
    const token = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || ""
    const body = new URLSearchParams(from ? { emplacement: from } : {})
    fetch(this.trackUrlValue, { method: "POST", headers: { "X-CSRF-Token": token }, body, keepalive: true }).catch(() => {})
  }

  _toast(message: string) {
    this.toastTarget.textContent = message
    this.toastTarget.classList.add("is-on")
    clearTimeout(this._timer)
    this._timer = window.setTimeout(() => this.toastTarget.classList.remove("is-on"), 2400)
  }
}
